import { render, staticRenderFns } from "./trainingSetup.vue?vue&type=template&id=2b4dc5db&scoped=true"
import script from "./trainingSetup.vue?vue&type=script&lang=js"
export * from "./trainingSetup.vue?vue&type=script&lang=js"
import style0 from "./trainingSetup.vue?vue&type=style&index=0&id=2b4dc5db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4dc5db",
  null
  
)

export default component.exports